import type { SheetVersion as GQLItem } from '../../../generated/api.graphql';
import { take } from '../../../util';

export type SheetVersion = {
  id: number;
  version: number;
  versionName?: string;
};

export const fromGql = (item: GQLItem): SheetVersion =>
  take<SheetVersion, GQLItem>(item, 'id', 'version', 'versionName');
